import React from "react";
import { ButtonWithLoader } from "@design-system/Button/ButtonWithLoader";
import { useConnectGmail } from "./useConnectGmail";

interface ConnectGmailButtonProps {
    /** Called after the Gmail sending domain is successfully created. */
    onConnected?: () => void;
}

export const ConnectGmailButton: React.FC<ConnectGmailButtonProps> = ({
    onConnected,
}) => {
    const { connect, isConnecting } = useConnectGmail({ onConnected });

    return (
        <ButtonWithLoader
            variant="secondary"
            size="md"
            type="button"
            loading={isConnecting}
            onClick={connect}
        >
            Connect Gmail
        </ButtonWithLoader>
    );
};
